
export enum OrdersFolders
{
    Open = "OpenOrders",
    Closed = "ClosedOrders"
}
